/* eslint-disable @typescript-eslint/dot-notation */
import { Component, ElementRef, HostListener, ViewChildren, QueryList, ViewEncapsulation, AfterContentChecked } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { ConfigData } from '../../models/configData';
import { FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';

@Component({
    selector: 'se-ellipsis-with-tooltip-cell-renderer',
    templateUrl: './ellipsis-with-tooltip-cell-renderer.component.html',
    styleUrls: ['./ellipsis-with-tooltip-cell-renderer.component.scss'],
    providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: ConfigData.tooltipConfiguration }],
    encapsulation: ViewEncapsulation.None
})
export class EllipsisWithTooltipCellRendererComponent implements ICellRendererAngularComp, AfterContentChecked /* AfterViewChecked */ {
    public viewFieldName!: string;
    public isArray!: boolean;
    public isRequired!: boolean;

    originalValue: any;
    viewValue!: string;
    viewValueArray!: Array<string>;
    disabled!: boolean;
    params!: ICellRendererParams;

    // ------- VALIDATION
    formGroup!: FormGroup;
    key!: string;
    columnName: string | undefined;
    // -------

    isInvalid!: boolean;


    @ViewChildren('cellContent') elementRefs: QueryList<ElementRef> | undefined;

    @HostListener('resize', ['$event']) onresizecol(_: any) {
        this.enableOrDisableTooltip();
    }

    agInit(params: ICellRendererParams): void {
        this.params = params;

        this.originalValue = params.value;
        this.configCellEditor();
        this.defineViewValue(params.value);

        // ------ VALIDATION
        this.columnName = params.colDef.headerName;
        this.key = params.context.createKey(params.node, params.column);
        // ------
    }

    //ngAfterViewChecked(): void {
    ngAfterContentChecked(): void {
        setTimeout(() => this.enableOrDisableTooltip(), 0);
        this.formGroup = this.params.context.formGroup;
        if (!this.formGroup.controls[this.key]) {
            this.formGroup.addControl(this.key,
                new FormControl(this.isArray ? this.viewValueArray : this.viewValue,
                    this.isRequired ? [Validators.required] : [])
            );

        }
        this.formGroup.controls[this.key].patchValue(this.isArray ? this.viewValueArray || [] : this.viewValue);

        this.showStatus(this.formGroup.controls[this.key]);
    }

    // ---- VALIDATION
    refresh(params: ICellRendererParams): boolean {
        this.formGroup = params.context.formGroup;

        if (!this.formGroup.controls[this.key]) {
            this.formGroup.addControl(this.key,
                new FormControl(this.isArray ? this.viewValueArray : this.viewValue,
                    this.isRequired ? [Validators.required] : [])
            );
        }

        this.defineViewValue(params.getValue());
        if (this.isArray) {
            this.formGroup.controls[this.key]?.patchValue(this.viewValueArray || []);
        } else {
            this.formGroup.controls[this.key]?.patchValue(this.viewValue);
        }
        this.showStatus(this.formGroup.controls[this.key]);
        return false;
    }
    // -----

    private showStatus(control: AbstractControl): void {
        if (control?.status === 'INVALID') {
            this.isInvalid = true;
        } else {
            this.isInvalid = false;
        }
    }

    private enableOrDisableTooltip() {
        if (!this.elementRefs || this.elementRefs.length === 0) {
            this.disabled = true;
        } else {
            let elementRefsArraySorted = this.elementRefs.toArray().sort((a, b) => {
                let aOffsetWidth = a.nativeElement.offsetWidth;
                let bOffsetWidth = b.nativeElement.offsetWidth;
                return aOffsetWidth - bOffsetWidth;
            });
            const element = elementRefsArraySorted.pop().nativeElement;

            this.disabled = this.params ? element.offsetWidth < (this.params.column.getActualWidth() - (element.offsetLeft * 2)) : false;
        }
    }

    private configCellEditor() {
        this.viewFieldName = this.params['viewFieldName'] || null;
        this.isArray = this.params['isArray'] || false;
        this.isRequired = this.params['required'] || false;

    }

    // ------ VALIDATION
    private defineViewValue(value): void {

        if (this.isArray) {
            if (!value) {
                this.viewValueArray = [];
                return;
            }
            this.viewValueArray = this.viewFieldName
                ? value.map((elem) => elem ? elem[this.viewFieldName] : null)
                : value;
        } else {
            this.viewValue = this.viewFieldName
                ? (value ? value[this.viewFieldName] : null)
                : value;
        }
    }
    // -----
}
